// global api
import CryptoJS from 'crypto-js'
import axios from 'axios'
import store from '../store'

// Request interceptor
axios.interceptors.request.use(request => {
  store.dispatch('setLoading', true)
  const apiUser = process.env.VUE_APP_API_USER
  const apiKey = process.env.VUE_APP_API_KEY
  const d = new Date()
  const e = d.toString().split(' ')
  e[4] = d.getUTCHours() + e[4].slice(2)
  const dateString = e[0] + ', ' + e[2] + ' ' + e[1] + ' ' + e[3] + ' ' + e[4] + ' +0000'
  // console.log('request.url')
  // console.log(request)
  const action = (request.url !== undefined) ? request.url.replace(process.env.VUE_APP_API_BASE_URL, '') : ''

  let payload = ''
  if (request.method.toLowerCase() === 'post') {
    payload = JSON.stringify(request.data)
  }
  // else {
  //   console.log('asdf')
  // }
  const enc = CryptoJS.HmacSHA256(payload, apiKey)
  const authStr = request.method.toUpperCase() + dateString + action + apiUser + enc
  const sig = CryptoJS.HmacSHA256(authStr, apiKey)
  const header = 'BSLSig user=' + apiUser + ', sig=' + sig + ', hash=' + enc + ', created=' + dateString
  request.headers.common['x-bslsig'] = header

  return request
}, error => {
  return Promise.reject(error)
})

// Response interceptor
axios.interceptors.response.use(response => {
  store.dispatch('setLoading', false)
  return response
}, async (error) => {
  console.log(error)
  // const originalRequest = error.config
  // if (error.response.status === 401 && !originalRequest._retry) {
  //   try {
  //     const refreshAccessTokenResult = await api.get(store.getters.appEndpoints.refreshAccessToken, this)

  //     if (refreshAccessTokenResult.access_token !== null) {
  //       originalRequest._retry = true
  //       store.dispatch('setAccessToken', refreshAccessTokenResult.access_token)
  //       originalRequest.headers.Authorization = 'Bearer ' + refreshAccessTokenResult.access_token

  //       originalRequest._retry = true
  //       return await axios(originalRequest)
  //     }
  //   } catch (error) {
  //     //
  //   }
  // }
  store.dispatch('setLoading', false)
  return Promise.reject(error)
})
